<template>
  <div class="fansShow">
    <van-sticky>
      <div
        class="fansShowNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../assets/member/back.png"
        />
        <span class="navTitle">粉丝说明</span>
      </div>
    </van-sticky>
    <div class="content">
      <div class="card">
        <div class="title">我的粉丝</div>
        <div class="tip">
          <p>我的粉丝=专属粉丝+推荐粉丝</p>
        </div>
      </div>
      <div class="card">
        <div class="title">专属粉丝</div>
        <div class="tip">
          <span>1、</span>
          <p>通过我的分享页注册成功的新用户</p>
        </div>
        <div class="tip">
          <span>2、</span>
          <p>用户首次授权进入我分享的销巴小程序，则成为我的专属粉丝</p>
        </div>
        <div class="tip">
          <span>3、</span>
          <p>
            用户首次通过微信/支付宝成功扫销巴商家二维码后，该用户成为对应商家微信/支付宝来源的专属粉丝
          </p>
        </div>
      </div>
      <div class="card">
        <div class="title">推荐粉丝</div>
        <div class="tip">
          <p>我的专属粉丝邀请注册的新用户</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isiOSX: false,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
  },
  methods: {
    goBack() {
      this.params("", "", "goBack");
    },
  },
};
</script>
<style lang="less" scoped>
.fansShow {
  min-height: 100%;
  .fansShowNav {
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .content {
    margin: 0 24px;
    .card {
      margin-top: 32px;
      .title {
        display: inline-block;
        font-size: 20px;
        font-weight: bold;
        color: #333333;
        line-height: 24px;
        height: 18px;
        margin-bottom: 12px;
        border-bottom: 5px solid #ffaf91;
      }
      .tip {
        font-size: 14px;
        color: #666666;
        line-height: 24px;
        display: flex;
      }
    }
  }
}
</style>
